/**
 * 画面描述匹配度(clip skip)
 */

import { InputNumber, Tooltip } from 'antd'
import classNames from 'classnames'
import { MySlider } from '~/components/ui/MySlider'
import { QuestionCircleOutlined } from '@ant-design/icons'

import styles from '../AiForm.module.css'
import { clipSkipAtom } from './atom'
import { useAtom } from 'jotai'

interface Props {
  disabled?: boolean
}

export function ClipSkipComp({ disabled = false }: Props) {
  const [clipSkip, setClipSkip] = useAtom(clipSkipAtom)

  return (
    <div className="flex items-center mb-3">
      <span className={classNames('text-neutral-500 w-[120px]')}>
        Clip skip{' '}
        <Tooltip
          placement="topLeft"
          arrowPointAtCenter
          title="画面描述匹配度（Clip skip）的值表示你希望画面描述对于模型主题来说匹配的准确度"
        >
          <QuestionCircleOutlined />
        </Tooltip>
      </span>
      <MySlider
        className="flex-1"
        step={1}
        min={0}
        max={12}
        value={clipSkip}
        onChange={val => {
          setClipSkip(val)
        }}
        tooltip={{ formatter: null }}
        disabled={disabled}
      />
      <InputNumber
        min={0}
        max={12}
        className={styles.inputNumber}
        value={clipSkip}
        onChange={val => {
          setClipSkip(Number(val?.toFixed(0)))
        }}
        disabled={disabled}
      />
    </div>
  )
}
